module.exports = __webpack_public_path__ + "static/media/8_cavity-math_lets-see-how.5ba0a6e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/8_cavity-math_lets-see-how.mp3
// module id = qB0v
// module chunks = 0